import useClickOutside from 'components/useClickOutSide';
import { Color, RadiobuttonGroup } from '@usitsdasdesign/dds-react'
import Icon from 'atoms/Icon'
import Text from 'atoms/Text';
import React, { useRef, useState } from 'react'
import ActionDropBox from './ActionDropBox';

function SortingDrop({ watch, name, label, onChange, onRemove }) {

    const [showFilter, setShowFilter] = useState(false);
    const ref = useRef();

    useClickOutside(ref, () => setShowFilter(false));

    const actionButtons = [
        {
            label: 'Remove',
            kind: 'silent',
            onClick: onRemove
        },
        {
            label: 'Close',
            kind: 'secondaryLoud',
            onClick: () => setShowFilter(false),
            className: '!flex md:!hidden'
        },
        {
            label: 'Ok',
            onClick: () => {
                setShowFilter(false);
            }
        }
    ];

    return (
        <div className='relative'>
            <div
                className='border max-w-[200px] bg-white border-gray-200 px-2 py-1 text-xs flex justify-between items-center gap-3 cursor-pointer'
                onClick={() => setShowFilter(!showFilter)}
            >
                <Text className='truncate' variant='label' title={label}>{label}</Text>
                <Icon icon='chevron_down__l__stroke' size='w-3 h-3' />
                <div className='border-l pl-1'>
                    <Icon icon={watch(name) === 'ascending' ? 'arrow_up__l__stroke' : 'arrow_down__l__stroke'} size='w-3 h-3' />
                </div>
            </div>
            {
                showFilter && (
                    <div ref={ref}>
                        <ActionDropBox
                            label={label}
                            onClose={() => setShowFilter(false)}
                            buttons={actionButtons}
                            height='h-full md:h-36'
                        >
                            <Text variant='body' className='mb-4'>{label}</Text>
                            <RadiobuttonGroup
                                color={Color.dark}
                                name={name}
                                direction={"row"}
                                radiobuttonItems={[
                                    {
                                        value: "ascending",
                                        label: "Ascending",
                                        isActive: watch(name) === 'ascending',
                                        isDisabled: false,
                                    },
                                    {
                                        value: "descending",
                                        label: "Descending",
                                        isActive: watch(name) === 'descending',
                                        isDisabled: false,
                                    }
                                ]}
                                onChangeHandler={onChange}
                            />
                        </ActionDropBox>
                    </div>
                )
            }
        </div>
    )
}

export default SortingDrop